var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookGlyph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4 12.75l.55-3.53h-3.39V6.93c0-.97.48-1.9 2-1.9h1.55V2.02s-1.4-.24-2.74-.24c-2.8 0-4.62 1.69-4.62 4.75v2.69H5.65v3.53h3.1V21h3.81v-8.25h2.84z",
    fill: "#01152E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookGlyph);
export default __webpack_public_path__ + "static/media/facebook-glyph.b76b65884783796d5e936fb9ec9171e5.svg";
export { ForwardRef as ReactComponent };